import React from "react"

const AboutArctus = ({ title, content }) => {
	return (
		<aside className='max-950 ma p20 grey-100'>
			<p className='xlarge grey pb20'>{title}</p>
			<article className='large grey-100 lh15 op-75 about--content' dangerouslySetInnerHTML={{ __html: content }} />
		</aside>
	)
}

export default AboutArctus
